"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGolfDayDistribution = void 0;
const getGolfDayDistribution = (number_of_rounds, number_of_night) => {
    if (number_of_night === 1) {
        if (number_of_rounds === 1)
            return [false, true];
        if (number_of_rounds === 2)
            return [true, true];
    }
    if (number_of_night === 2) {
        if (number_of_rounds === 1)
            return [false, true, false];
        if (number_of_rounds === 2)
            return [false, true, true];
        if (number_of_rounds === 3)
            return [true, true, true];
    }
    if (number_of_night === 3) {
        if (number_of_rounds === 1)
            return [false, true, false, false];
        if (number_of_rounds === 2)
            return [false, true, true, false];
        if (number_of_rounds === 3)
            return [false, true, true, true];
        if (number_of_rounds === 4)
            return [true, true, true, true];
    }
    if (number_of_night === 4) {
        if (number_of_rounds === 1)
            return [false, true, false, false, false];
        if (number_of_rounds === 2)
            return [false, true, false, true, false];
        if (number_of_rounds === 3)
            return [false, true, true, true, false];
        if (number_of_rounds === 4)
            return [false, true, true, true, true];
        if (number_of_rounds === 5)
            return [true, true, true, true, true];
    }
    if (number_of_night === 5) {
        if (number_of_rounds === 1)
            return [false, false, true, false, false, false];
        if (number_of_rounds === 2)
            return [false, true, false, true, false, false];
        if (number_of_rounds === 3)
            return [false, true, true, false, true, false];
        if (number_of_rounds === 4)
            return [false, true, true, true, true, false];
        if (number_of_rounds === 5)
            return [false, true, true, true, true, true];
        if (number_of_rounds === 6)
            return [true, true, true, true, true, true];
    }
    if (number_of_night === 6) {
        if (number_of_rounds === 1)
            return [false, false, true, false, false, false, false];
        if (number_of_rounds === 2)
            return [false, false, true, false, true, false, false];
        if (number_of_rounds === 3)
            return [false, true, false, true, false, true, false];
        if (number_of_rounds === 4)
            return [false, true, true, false, true, true, false];
        if (number_of_rounds === 5)
            return [false, true, true, true, true, true, false];
        if (number_of_rounds === 6)
            return [false, true, true, true, true, true, true];
        if (number_of_rounds === 7)
            return [true, true, true, true, true, true, true];
    }
    if (number_of_night === 7) {
        if (number_of_rounds === 1)
            return [false, false, false, true, false, false, false, false];
        if (number_of_rounds === 2)
            return [false, false, true, false, true, false, false, false];
        if (number_of_rounds === 3)
            return [false, true, false, true, false, true, false, false];
        if (number_of_rounds === 4)
            return [false, true, true, false, true, false, true, false];
        if (number_of_rounds === 5)
            return [false, true, true, true, false, true, true, false];
        if (number_of_rounds === 6)
            return [false, true, true, true, true, true, true, false];
        if (number_of_rounds === 7)
            return [false, true, true, true, true, true, true, true];
        if (number_of_rounds === 8)
            return [true, true, true, true, true, true, true, true];
    }
    if (number_of_night === 8) {
        if (number_of_rounds === 1)
            return [false, false, false, true, false, false, false, false, false];
        if (number_of_rounds === 2)
            return [false, false, true, false, true, false, false, false, false];
        if (number_of_rounds === 3)
            return [false, true, false, true, false, true, false, false, false];
        if (number_of_rounds === 4)
            return [false, true, true, false, true, false, true, false, false];
        if (number_of_rounds === 5)
            return [false, true, true, true, false, true, false, true, false];
        if (number_of_rounds === 6)
            return [false, true, true, true, true, false, true, true, false];
        if (number_of_rounds === 7)
            return [false, true, true, true, true, true, true, true, false];
        if (number_of_rounds === 8)
            return [false, true, true, true, true, true, true, true, true];
        if (number_of_rounds === 9)
            return [true, true, true, true, true, true, true, true, true];
    }
    if (number_of_night === 9) {
        if (number_of_rounds === 1)
            return [
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 2)
            return [
                false,
                false,
                false,
                true,
                false,
                true,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 3)
            return [
                false,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 4)
            return [false, true, false, true, false, true, false, true, false, false];
        if (number_of_rounds === 5)
            return [false, true, true, false, true, false, true, false, true, false];
        if (number_of_rounds === 6)
            return [false, true, true, true, false, true, true, false, true, false];
        if (number_of_rounds === 7)
            return [false, true, true, true, true, false, true, true, true, false];
        if (number_of_rounds === 8)
            return [false, true, true, true, true, true, false, true, true, true];
        if (number_of_rounds === 9)
            return [false, true, true, true, true, true, true, true, true, true];
    }
    if (number_of_night === 10) {
        if (number_of_rounds === 1)
            return [
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 2)
            return [
                false,
                false,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 3)
            return [
                false,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 4)
            return [
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 5)
            return [
                false,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
            ];
        if (number_of_rounds === 6)
            return [
                false,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
            ];
        if (number_of_rounds === 7)
            return [
                false,
                true,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 8)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                false,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 9)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 10)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
            ];
        if (number_of_rounds === 11)
            return [true, true, true, true, true, true, true, true, true, true, true];
    }
    if (number_of_night === 11) {
        if (number_of_rounds === 1)
            return [
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 2)
            return [
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 3)
            return [
                false,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 4)
            return [
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                false,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 5)
            return [
                false,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                false,
                true,
                false,
            ];
        if (number_of_rounds === 6)
            return [
                false,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
            ];
        if (number_of_rounds === 7)
            return [
                false,
                true,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
            ];
        if (number_of_rounds === 8)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 9)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 10)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 11)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
            ];
        if (number_of_rounds === 12)
            return [
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
            ];
    }
    if (number_of_night === 12) {
        if (number_of_rounds === 1)
            return [
                false,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 2)
            return [
                false,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 3)
            return [
                false,
                false,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 4)
            return [
                false,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 5)
            return [
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 6)
            return [
                false,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 7)
            return [
                false,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
            ];
        if (number_of_rounds === 8)
            return [
                false,
                true,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 9)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 10)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
                true,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 11)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 12)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
            ];
        if (number_of_rounds === 13)
            return [
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
            ];
    }
    if (number_of_night === 13) {
        if (number_of_rounds === 1)
            return [
                false,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 2)
            return [
                false,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 3)
            return [
                false,
                false,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 4)
            return [
                false,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 5)
            return [
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 6)
            return [
                false,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 7)
            return [
                false,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 8)
            return [
                false,
                true,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 9)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                true,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 10)
            return [
                false,
                true,
                true,
                true,
                false,
                true,
                true,
                true,
                false,
                true,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 11)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 12)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 13)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
            ];
        if (number_of_rounds === 14)
            return [
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
            ];
    }
    if (number_of_night === 14) {
        if (number_of_rounds === 1)
            return [
                false,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 2)
            return [
                false,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 3)
            return [
                false,
                false,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 4)
            return [
                false,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 5)
            return [
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                true,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 6)
            return [
                false,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 7)
            return [
                false,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 8)
            return [
                false,
                true,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                false,
                true,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 9)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                false,
                true,
                false,
                true,
                true,
                true,
                false,
                false,
                false,
            ];
        if (number_of_rounds === 10)
            return [
                false,
                true,
                true,
                true,
                false,
                true,
                true,
                true,
                false,
                true,
                true,
                true,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 11)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 12)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
                false,
            ];
        if (number_of_rounds === 13)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                false,
            ];
        if (number_of_rounds === 14)
            return [
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
            ];
        if (number_of_rounds === 15)
            return [
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
            ];
    }
};
exports.getGolfDayDistribution = getGolfDayDistribution;
